<template>
  <a-modal title="祺信变更" v-model="modalShow" width="400px" @ok="handleOk" @cancel="handleCancel"
    :confirm-loading="confirmLoading" destroyOnClose>
    <div class="spaceCenter">
      <div class="text-item spaceLeft">
        <div class="text-label">祺信编号：</div>
        {{ info.gldId }}
      </div>
      <div class="text-item spaceLeft">
        <div class="text-label">祺信面额：</div>
        {{ info.gldAmt | splitK }}
      </div>
      <div class="text-item spaceLeft">
        <div class="text-label">接收方：</div>
        {{ info.rcPtyNm }}
      </div>
      <div class="text-item spaceLeft">
        <div class="text-label">到期日期：</div>
        {{ info.exDay | dateFormat("YYYY-mm-dd") }}
      </div>
      <div class="text-item spaceLeft">
        <div class="text-label">新到期日期：</div>
        <a-date-picker valueFormat="YYYY-MM-DD" v-model="afterModified" :disabled-date="disabledDate"
          style="width: 210px" />
      </div>
      <div class="text-item spaceLeft">
        <div class="text-label">交易密码：</div>
        <a-input v-model="pwd" style="width: 210px" type="password" />
      </div>
    </div>
  </a-modal>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import {
  verifyTradePassword,
  GoldenbillBuyerModifiedAPI,
  existOnTheWay,
} from "@/api/gold.js";
import { queryByDate } from "@/api/center.js";
export default {
  props: {
    info: {
      type: [Object],
      default: function () {
        return {};
      },
    },
    paramValue: {
      type: [Number],
      default: function () {
        return null;
      },
    }
  },
  components: {},
  name: "gold-detail-dialog",
  data() {
    return {
      afterModified: "",
      modalShow: false,
      confirmLoading: false,
      pwd: "",
      holDayMap: {},
    };
  },
  computed: {
    ...mapGetters({
      userObj: "home/getUserObj",
      parentData: "app/getGoldDetailPrarms",
    }),
  },
  created() {
    // 一次获取三年的节假日
    let year = new Date(new Date()).getFullYear();
    Promise.all([
      this.getHolDays(year),
      this.getHolDays(year + 1),
      this.getHolDays(year + 2),
    ]).then((res) => { });
  },
  methods: {
    ...mapMutations({
      setBuyOrSell: "app/setBuyOrSell",
    }),
    getPymAmt() {
      let sum = 0;
      this.info.forEach((i) => {
        sum += Number(i.pymAmt);
      });
      this.pymAmt = sum;
      return sum;
    },
    open(data) {
      let that = this
      existOnTheWay(data.gldId).then((res) => {
        if (res.data) {
          this.$info({
            title: "存在在途子祺信，变更还款日期会将在途祺信全部撤回。",
            okText: "确认",
            onOk() {
              that.modalShow = true;
            },
          });
        } else {
          this.modalShow = true;
        }
      });
      //   this.modalShow = true;
    },
    close() {
      this.modalShow = false;
    },
    handleOk() {
      this.confirmLoading = true;
      let txnPwd = this.pwd;
      verifyTradePassword({
        tradePassword: txnPwd,
      })
        .then((resPwd) => {
          let param = {
            txnPwd: this.utils.getPasswordEncryptString(this.pwd),
            gldId: this.info.gldId,
            beforeModified: this.info.exDay,
            afterModified: this.afterModified,
          };
          GoldenbillBuyerModifiedAPI(param)
            .then((res) => {
              this.confirmLoading = false;
              this.$message.success("已提交成功,请等待复核！");
              this.close();
              this.$emit("success");
            })
            .catch((err) => {
              this.confirmLoading = false;
            });
        })
        .catch((err) => {
          this.confirmLoading = false;
        });
    },
    // 获取节假日
    getHolDays(year) {
      if (year) {
        return new Promise((resolve, reject) => {
          queryByDate({
            date: year,
          })
            .then((res) => {
              this.holDayMap[year] = res.data || [];
              resolve();
            })
            .catch((err) => {
              reject();
            });
        });
      }
    },
    // 判断是否为休息日或者是节假日
    isHolOrRest(year, value) {
      const list = this.holDayMap[year] || [];
      const item = list.find((i) => i.holDt == value || i.holDt == value + " 00:00:00");
      if (item) {
        return {
          ...item,
          result: true,
        };
      } else {
        return null;
      }
    },
    disabledDate(cuurent) {
      // 节假日
      let data_value = this.utils.getDate(cuurent, "YYYY-mm-dd");
      const year = new Date(cuurent).getFullYear();
      if (this.isHolOrRest(year, data_value)) {
        return true;
      }

      // 小于T+10 都禁用
      let today = undefined; //最大
      let curDay = new Date(cuurent).getTime();
      let exDay = undefined; //最小


      // 此处为处理日期插件问题，无实际意义-开始
      // if(this.afterModified){
      //     today = new Date(this.utils.addDate(new Date(),1)).getTime();
      //     exDay = new Date(this.info.exDay).getTime();
      // }else{
      //     today = new Date(this.utils.addDate(new Date(),0)).getTime();
      //     exDay = new Date(this.utils.addDate(this.info.exDay,1)).getTime();
      // }
      // console.log(this.afterModified)
      //   today = new Date().getTime();

      exDay = new Date(this.info.exDay).getTime();
      if (this.afterModified) {
        today = new Date(this.utils.addDate(new Date(), this.paramValue)).getTime();
      } else {
        today = new Date(this.utils.addDate(new Date(), this.paramValue)).getTime();
      }
      // 此处为处理日期插件问题-结束
      return curDay < today || curDay > exDay;


      // today = Date.now() - 1000*60*60*24
      // exDay = new Date(this.info.exDay).getTime();
      // if (curDay < today) {
      //   return true;
      // }
      // // 大于当前到期日
      // if (exDay < curDay) {
      //   return true;
      // }
    },
    handleCancel() {
      this.pwd = "";
      this.afterModified = "";
    },
  },
  watch: {},
  activated() { },
};
</script>
<style scoped lang="less">
.text-item {
  width: 100%;
  margin-bottom: 10px;
  color: #333;
}

.text-label {
  width: 90px;
  text-align: right;
  color: #777;
}
</style>



// WEBPACK FOOTER //
// src/components/gold-page/change-modal.vue